import Api from "../../utils/axios";

export const TaxRegimeApi = {
  createTaxRegime: (payload) => Api.post(`master/create-tax-regime`, payload),
  updateTaxRegime: (id, payload) => Api.put(`master/update-tax-regime/${id}`, payload),
  getTaxRegimeById: (id) => Api.get(`master/get-tax-regime/${id}`), 
  getAllRegimeApi: (payload,search="") => Api.post(`master/get-all-tax-regime?search=${search}`,payload), 
  getAllTaxMaster: () => Api.get(`master/get-all-tax`), 
};